import Vue from "vue";
import VueRouter from "vue-router";
import TopMenu from "../layouts/TopMenu";
import Login from "../views/Login";
import Register from "../views/Register";
import ErrorPage from "../views/ErrorPage";
import Transaction from "../views/Transaction";
import TakeIn from "../views/TakeIn";
import TakeOut from "../views/TakeOut";
import HandAmount from "../views/HandAmount";
import TransHistory from "../views/TransHistory";
import Statistic from "../views/Statistic";
import AgencyPage from "../views/AgencyPage";
import AdminPage from "../views/AdminPage";

Vue.use(VueRouter);

const routes = [
  {
    path: "/main",
    component: TopMenu,
    children: [
      {
        path: "agency-list",
        name: "agency-list",
        component: AgencyPage
      },
      {
        path: "admin-list",
        name: "admin-list",
        component: AdminPage
      },
      {
        path: "transaction",
        name: "transaction",
        component: Transaction
      },
      {
        path: "take-in",
        name: "take-in",
        component: TakeIn
      },
      {
        path: "take-out",
        name: "take-out",
        component: TakeOut
      },
      {
        path: "hand-amount",
        name: "hand-amount",
        component: HandAmount
      },
      {
        path: "trans-history",
        name: "trans-history",
        component: TransHistory
      },
      {
        path: "statistic",
        name: "statistic",
        component: Statistic
      }
    ]
  },
  {
    path: "/",
    name: "login",
    component: Login
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/error-page",
    name: "error-page",
    component: ErrorPage
  },
  {
    path: "/*",
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
